<template>
  <div>
    <comment-form-modal :action="handleSubmitCommentForm" />
    <el-dropdown split-button type="success" @click="handleStatusChange({ status: 'approved' })" @command="handleOpenCommentModal" v-if="pto.status !== 'approved'">
      <i class="fa fa-check"></i> Approve
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="approved">Approve with comment</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown split-button type="danger" @click="handleStatusChange({ status: 'rejected' })" @command="handleOpenCommentModal" v-if="pto.status !== 'rejected'">
      <i class="fa fa-ban"></i> Reject
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="rejected">Reject with comment</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import commentConstants from '@/store/modules/comment/constants';
  import CommentFormModal from '@/components/comment/CommentFormModal';
  import { EventBus } from '@/components/event-bus';

  export default {
    name: 'PtoStatusButtons',
    components: {
      commentFormModal: CommentFormModal,
    },
    props: {
      pto: {
        type: Object,
        required: true,
      },
      onStatusChange: {
        type: Function,
      },
    },
    methods: {
      ...mapActions('entities/ptos', ['changeStatus']),
      ...mapActions('entities/comments', ['openFormModal', 'closeFormModal']),

      handleStatusChange(data) {
        this.$confirm('Do you want to change status of this PTO?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.handleCloseCommentModal();

          this.changeStatus({ id: this.pto.id, data })
            .then((response) => {
              if (response.status) {
                if (this.onStatusChange) this.onStatusChange(response, data);
                EventBus.$emit('refresh-header');
                this.$store.dispatch('entities/timeLogs/deleteAll');
                this.$message({ type: 'success', message: 'Status has been changed successfully.' });
              } else {
                this.$message({ type: 'error', message: response.error });
              }
            });
        });
      },

      handleOpenCommentModal(command) {
        const buttonText = command === 'approved' ? 'Approve' : 'Reject';
        const label = command === 'approved' ? commentConstants.LABELS.ptoApproved : commentConstants.LABELS.ptoRejected;

        this.openFormModal({ id: this.pto.id, type: 'Pto', label, command, buttonText });
      },

      handleCloseCommentModal() {
        this.closeFormModal();
      },

      handleSubmitCommentForm(command, commentData) {
        this.handleStatusChange({ status: command, comments_attributes: commentData });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/pto/PtoStatusButtons.vue